import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../assets/close.svg'


const _hoisted_1 = { class: "dialog" }
const _hoisted_2 = { class: "pane" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "text" }
const _hoisted_5 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.title), 1),
        _createElementVNode("img", {
          src: _imports_0,
          alt: "X",
          class: "close",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onCancel && _ctx.onCancel(...args)))
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("p", null, _toDisplayString(_ctx.text), 1)
      ]),
      (!_ctx.query)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "change",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onCancel && _ctx.onCancel(...args)))
          }, "关闭"))
        : _createCommentVNode("", true),
      (_ctx.query)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "change",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onQuery && _ctx.onQuery(...args)))
          }, "查询订单"))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: "overlay",
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onCancel && _ctx.onCancel(...args)))
    })
  ]))
}